import { useEffect, useMemo, useState } from "react";
import { api, setSEO } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import SizingNote from "@/components/SizingNote";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "Tops", label: "Tops" },
  { key: "Shrugs / Layering", label: "Shrugs / Layering" },
  { key: "Bodysuits", label: "Bodysuits" },
  { key: "Sports Bras", label: "Sports Bras" },
  { key: "Biker Shorts", label: "Biker Shorts" },
  { key: "Joggers", label: "Joggers" },
  { key: "Accessories", label: "Accessories" },
  { key: "Contraband", label: "Contraband" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [active, setActive] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setSEO({
      title: "Shop FEMBOT NEX | Funny, Offensive & Edgy Activewear for Women",
      description:
        "Shop FEMBOT NEX limited-run cyber-femme activewear: crop tops, sports bras, biker shorts, joggers, mesh layers, and post-ironic gymwear for women.",
    });
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (active === "all") return products;
    if (active === "Contraband") return products.filter((p) => p.tier === "contraband");
    return products.filter((p) => p.category === active || p.subcategory === active);
  }, [products, active]);

  const visibleFilters = useMemo(() => {
    return FILTERS.filter((f) => {
      if (f.key === "all") return true;
      if (f.key === "Contraband") return products.some((p) => p.tier === "contraband");
      return products.some((p) => p.category === f.key || p.subcategory === f.key);
    });
  }, [products]);

  return (
    <div data-testid="shop-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-20">
      <div className="section-label">// CATALOG</div>
      <h1 className="mt-3 font-display text-5xl md:text-7xl tracking-tight leading-[0.9]">
        Shop <span className="text-[#ff1493]">FEMBOT NEX</span>
      </h1>
      <p className="mt-6 max-w-2xl text-[#a3a3a3] leading-relaxed">
        The full archive. Drop 001 mainline pieces and restricted contraband files. Authorize uplink to be first in line.
      </p>

      <div className="mt-8">
        <SizingNote />
      </div>

      <div className="mt-10 flex flex-wrap gap-2" data-testid="shop-filters">
        {visibleFilters.map((f) => (
          <button
            key={f.key}
            onClick={() => setActive(f.key)}
            data-testid={`shop-filter-${f.key.toLowerCase().replace(/\s+/g, "-")}`}
            className={`btn-ghost ${active === f.key ? "text-white border-[#ff1493]" : ""}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-14">
        {loading && (
          <div className="p-10 font-mono text-xs tracking-[0.24em] uppercase text-[#7a6a90] col-span-full">
            // loading catalog...
          </div>
        )}
        {!loading && filtered.length === 0 && (
          <div className="p-10 font-mono text-xs tracking-[0.24em] uppercase text-[#7a6a90] col-span-full">
            // no records match the filter
          </div>
        )}
        {filtered.map((p) => (
          <ProductCard key={p.slug} product={p} locked={p.tier === "contraband"} />
        ))}
      </div>
    </div>
  );
}
